import { CLIENT_METHODS, RESOURCES, useApiMutation } from '@/data/api'

export const useVerifyMFAcode = (): ReturnType<typeof useApiMutation> =>
  useApiMutation(RESOURCES.MFA, CLIENT_METHODS.POST)
